var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 20V21.3333C24 22.8 22.8 24 21.3333 24H2.66667C1.18667 24 0 22.8 0 21.3333V2.66667C0 1.2 1.18667 0 2.66667 0H21.3333C22.8 0 24 1.2 24 2.66667V4H12C10.52 4 9.33333 5.2 9.33333 6.66667V17.3333C9.33333 18.8 10.52 20 12 20H24ZM12 17.3333H25.3333V6.66667H12V17.3333ZM17.3333 14C16.2267 14 15.3333 13.1067 15.3333 12C15.3333 10.8933 16.2267 10 17.3333 10C18.44 10 19.3333 10.8933 19.3333 12C19.3333 13.1067 18.44 14 17.3333 14Z",
    fill: "url(#paint0_linear_3821_13653)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3821_13653",
    x1: 25.3333,
    y1: 12,
    x2: 1.35156e-7,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#800080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF864C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.9cd3451014e7193f58db9165d1b0b1e3.svg";
export { ForwardRef as ReactComponent };